const state = {
  catchName:[],
};
const getters = {
  getCatchName: state => {
    return state.catchName;
  }
};
const mutations = {
  addCatchName: (state, payload) => {
    state.catchName.push(payload);
  },
  removeCatchName: (state, payload) => {
    let index = state.catchName.indexOf(payload);
    if (index > -1 &&  state.catchName.length > 0) {
      state.catchName.splice(index, 1);
    }
  },
  removeOtherCatchName: (state, payload) => {
    state.catchName=[];
    state.catchName.push(payload)
  },
  removeAllCatchName: (state, payload) => {
    state.catchName=[];
  },
};
const actions = {
  addCatchName: (context, payload) => {
    context.commit("addCatchName", payload);
  },
  removeCatchName: (context, payload) => {
    context.commit("removeCatchName", payload);
  },
  removeOtherCatchName: (context, payload) => {
    context.commit("removeOtherCatchName", payload);
  },
  removeAllCatchName: (context, payload) => {
    context.commit("removeAllCatchName", payload);
  },
};
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/vuex/modules/view.js